import { DynamicViewPayload } from './dynamic-view-payload.type';
import { DynamicIndexViewPayload } from './dynamic-index-view-payload.interface';

export function isIndexDynamicViewPayload(payload: DynamicViewPayload): payload is DynamicIndexViewPayload {
  return (payload as any).index !== undefined;
}
